import creatorMusicCover from '../assets/musehub-creator-music-logo.png'
import landrFxVoiceCover from '../assets/musehub-landr-fx-voice-logo.png'
import overtuneArrangeCover from '../assets/musehub-overtune-arrange-logo.png'
import podcastEffectsMusicCover from '../assets/musehub-podcast-effects-music-logo.png'
import samplabCover from '../assets/musehub-samplab-logo.png'

export type TMusehubBannerId =
    | 'landrFxVoice'
    | 'creatorMusicSfxBundle'
    | 'samplab'
    | 'overtuneArrange'
    | 'podcastEffectsMusic'

export type TMusehubBannerContent = {
    cover: string
    label: string
    title: string
    description: string
    link: string
    offer?: string
}

// Marketing copy + UTM links are ported as-is from audio-web; only the CTA label is localised.
export const MUSEHUB_BANNERS: Record<TMusehubBannerId, TMusehubBannerContent> = {
    landrFxVoice: {
        cover: landrFxVoiceCover,
        label: 'LANDR FX Voice',
        title: 'Let your voice take center-stage in your mixes',
        description:
            'Polish, smooth, and control your vocals with everything from tastefully tailored EQ to epic reverb to full-on distortion with over 40 curated presets.',
        link: 'https://www.musehub.com/plugin/landr-fx-voice?utm_source=audio-com-web&utm_medium=banner&utm_campaign=landr-fx-voice',
    },
    creatorMusicSfxBundle: {
        cover: creatorMusicCover,
        label: 'Creator Music & SFX Bundle',
        title: 'Making videos, streaming, podcasting, or building the next viral clip?',
        description:
            'The Content Creator Music & SFX Bundle delivers 70 packs of hard-hitting tracks and sound effects to give your projects the fresh, pro edge they deserve.',
        link: 'https://www.musehub.com/loops-and-audio/creator-music-sfx-bundle-991?utm_source=audio-com-web&utm_medium=banner&utm_campaign=creator-music-sfx-bundle-991',
        offer: '96% OFF !',
    },
    samplab: {
        cover: samplabCover,
        label: 'Samplab',
        title: 'Seamlessly converts audio to MIDI',
        description:
            'A powerful audio-to-MIDI technology lets you fine-tune every note, harmony, and rhythm with precision, unlocking a new level of flexibility for producers, songwriters, and remix artists.',
        link: 'https://www.musehub.com/app/samplab?utm_source=audio-com-web&utm_medium=banner&utm_campaign=samplab',
    },
    overtuneArrange: {
        cover: overtuneArrangeCover,
        label: 'Overtune Arrange',
        title: 'Arrange professional-grade instrumentals using curated studio-quality loops',
        description:
            'The all-in-one beat creation platform for singers, rappers, and songwriters who want full creative freedom without complex tools.',
        link: 'https://www.musehub.com/app/overtune-arrange?utm_source=audio-com-web&utm_medium=banner&utm_campaign=overtune-arrange',
    },
    podcastEffectsMusic: {
        cover: podcastEffectsMusicCover,
        label: 'Podcast Effects & Music',
        title: 'Set the mood for any story with the Podcast Effects & Music Pack',
        description:
            'Blending R&B, country, funk, electronica, Latin, dance, and more, this versatile collection offers loops, beats, and themes to match any tone. This pack provides a full spectrum of audio elements to enhance your podcast production.',
        link: 'https://www.musehub.com/loops-and-audio/podcast-effects-music?utm_source=audio-com-web&utm_medium=banner&utm_campaign=podcast-effects-music',
    },
}

export const MUSEHUB_EXPLORE_ALL_URL =
    'https://www.musehub.com?utm_source=audio-com-web&utm_medium=banner&utm_campaign=explore-all'

export const MUSEHUB_SEE_ALL_PLACEMENT = 'Effects and Plugins'

export const MUSEHUB_STATIC_LABELS = {
    title: 'Effects and Plugins',
    exploreAll: 'explore all on musehub',
    cta: 'Try now',
}
